module.exports = __webpack_public_path__ + "static/media/black-add.6cf3d799.svg";